import { Component, Prop, Vue, Model, Watch } from 'vue-property-decorator';
import debounce from 'debounce';

@Component<MiGlobalSearch>({})
export default class MiGlobalSearch extends Vue {
  @Model('isLoading', { default: false })
  isLoading!: boolean;

  @Prop({ default: '' })
  protected icon!: string;

  @Prop({ default: false })
  protected disabled!: boolean;

  protected items: any[] = [];
  protected selected: any = null;
  protected search: string = '';
  protected isFocused: boolean = false;
  protected searchDebounce: Function = this.handleSearch();

  protected selectedItems = [
    {
      title: 'Atabix Solutions BV',
      subtitle: 'Subtitle - Item 1',
      icon: 'face',
      href: '/support',
    },
    {
      title: 'De eerste Rotterdamse Staalfabriek BV',
      subtitle: 'Subtitle - Item 2',
      icon: 'fingerprint',
      href: '/support'
    },
    {
      title: 'Title - Item 3',
      subtitle: 'Subtitle - Item 3',
      icon: 'favorite',
      href: '/support'
    },
    {
      title: 'Title - Item 4',
      subtitle: 'Subtitle - Item 4',
      icon: 'extension',
      href: '/support'
    },
  ]

  protected mounted() {
    //
  }

  protected handleSearch() {
    return debounce((searchInput: string) => {
      this.items = this.selectedItems;
    }, 400);
  }

  protected reset() {
    this.items = [];
    this.search = '';
    this.isFocused = false;
  }

  @Watch('search')
    protected searchInputChanged(search: string) {
      if(search) {
        this.searchDebounce(search);
      }
    }
}
